import { render } from "./App.vue?vue&type=template&id=9d13afa8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9d13afa8&lang=css"

import exportComponent from "D:\\CUFE24\\Cources\\Vue JS Net Ninja\\third-task-reaction-timer-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__